import React, { FC } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'

import Button from 'core/elements/button'
import Theme from 'core/themes/model'
import generateTestId from 'utils/test-helpers'

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    marginTop: theme.spacing(3),
  },
}))

interface Props {
  className?: string
  form?: any
  children: React.ReactNode | string
  icon?: string
  disabled?: boolean
}

const SubmitButton: FC<Props> = ({ className, children, form, icon, disabled }: Props) => {
  const classes = useStyles({})
  return (
    <Button
      data-testid={generateTestId(children)}
      className={clsx(classes.root, className)}
      type="submit"
      variant="primary"
      size="large"
      form={form}
      icon={icon}
      disabled={disabled}
    >
      {children}
    </Button>
  )
}

export default SubmitButton
